import axios from '../axios'

/* 
 * 备注信息管理
 */

/**
 * 查询历史备注信息
 * @param {*} service   服务模块 例：admin
 * @param {*} params    请求参数
 * @returns 
 */
export const findStringRemark = (service, params) => {
  return axios({
    url: '/' + service + '/api/remark/findStringRemark',
    method: 'get',
    params
  })
}

/**
 * 根据记录id获取历史备注信息列表，按创建时间排序
 * @param {*} service   服务模块 例：admin
 * @param {*} params    请求参数
 * @returns 
 */
export const findRemarkById = (service, params) => {
  return axios({
    url: '/' + service + '/api/remark/findRemarkByRecordId',
    method: 'get',
    params
  })
}

/**
 * 单个新增备注信息
 * @param {*} service   服务模块 例：admin
 * @param {*} data    请求参数
 * @returns 
 */
export const insertRemark = (service, data) => {
  return axios({
    url: '/' + service + '/api/remark/insertRemarkInfo',
    method: 'post',
    data
  })
}

/**
 * 批量新增备注信息
 * @param {*} service   服务模块 例：admin
 * @param {*} data    请求参数
 * @returns 
 */
export const insertRemarkInfoBatch = (service, data) => {
  return axios({
    url: '/' + service + '/api/remark/insertRemarkInfoBatch',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/remark.js